/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorErrorResponse } from './monitorErrorResponse';
import { MonitorState } from './monitorState';
import { MonitorMinResponse } from './monitorMinResponse';


/**
 * @type MonitorCreationItemDetails
 * @export
 */
export type MonitorCreationItemDetails = MonitorErrorResponse | MonitorMinResponse;

